import { h, FunctionalComponent } from 'preact'
import cn from 'classnames'
import s from './Loader.css'

interface iProps {
  className?: string
  size?: 'm' | 'l'
  color?: 'blue' | 'white' | 'dark'
}

export const Loader: FunctionalComponent<iProps> = (props) => {
  const {
    className,
    size = 'm',
    color = 'white'
  } = props

  return (
    <span className={cn(
      s.Loader,
      {
        [s.Loader_m]: size === 'm',
        [s.Loader_l]: size === 'l',
        [s.Loader_white]: color === 'white',
        [s.Loader_blue]: color === 'blue',
        [s.Loader_dark]: color === 'dark',
      },
      className)}/>
  )
}
